<template>
  <div id="June2025" class="202506">
    <router-link :to="{ name: 'index' }" class="mx-auto block p-2">
      <img src="~@/assets/images/202506/logo.png" class="object-contain mx-auto">
    </router-link>

    <div class="">
      <img src="~@/assets/images/202506/head.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202506/top.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202506/m/head.png" class="object-contain mx-auto md:hidden">
    </div>

    <div class="flex flex-wrap max-w-6xl mx-auto books rounded p-2">
      <router-link target="_blank" :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/3 md:w-1/4 p-3 border border-black border-dashed" v-for="(item, index) in bookData" :key="index"
        :class="{ 'md:border-t-0': ([0, 1, 2, 3].indexOf(index) > -1), 'md:border-r-0': ([3, 7, 11, 15, 19].indexOf(index) > -1), 'md:border-b-0': ([16, 17, 18, 19].indexOf(index) > -1), 'md:border-l-0': ([0, 4, 8, 12, 16].indexOf(index) > -1)}">
        <img :src="item.img_url" class="object-contain block mx-auto">
      </router-link>
    </div>
    <a class="block md:p-2" target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=500">
      <img src="~@/assets/images/202506/bt-more.png" class="object-contain mx-auto">
    </a>
    <a class="block" target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=501">
      <img src="~@/assets/images/202506/mag.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202506/m/mag.png" class="object-contain mx-auto md:hidden">
    </a>
    <div class="">
      <img src="~@/assets/images/202506/top2.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202506/m/top2.png" class="object-contain mx-auto md:hidden">
    </div>

    <div class="flex flex-wrap max-w-6xl mx-auto books rounded p-2">
      <router-link target="_blank" :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/3 md:w-1/4 p-3 border border-black border-dashed" v-for="(item, index) in bookData2" :key="index"
        :class="{ 'md:border-t-0': ([0, 1, 2, 3].indexOf(index) > -1), 'md:border-r-0': ([3, 7, 11, 15, 19].indexOf(index) > -1), 'md:border-b-0': ([16, 17, 18, 19].indexOf(index) > -1), 'md:border-l-0': ([0, 4, 8, 12, 16].indexOf(index) > -1)}">
        <img :src="item.img_url" class="object-contain block mx-auto">
      </router-link>
    </div>
    <a class="block md:p-2" target="_blank" href="https://store.liveabc.com/products/recent/sale?tag=502">
      <img src="~@/assets/images/202506/bt-more.png" class="object-contain mx-auto">
    </a>
    <router-link :to="{ name: 'index' }" class="mx-auto block">
      <img src="~@/assets/images/202506/foot.png" class="object-contain mx-auto hidden md:block">
      <img src="~@/assets/images/202506/m/foot.png" class="object-contain mx-auto md:hidden">
    </router-link>

  </div>
</template>
<script>
export default {
  name: 'October2024',
  metaInfo () {
    return {
      title: '畢業季限定，LiveABC打折兼送禮！',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: false,
      bookData: [
        { id: 10483, img_url: require('@/assets/images/202506/book/item1.png') },
        { id: 8742, img_url: require('@/assets/images/202506/book/item2.png') },
        { id: 7873, img_url: require('@/assets/images/202506/book/item3.png') },
        { id: 9958, img_url: require('@/assets/images/202506/book/item4.png') },
        { id: 8627, img_url: require('@/assets/images/202506/book/item5.png') },
        { id: 7496, img_url: require('@/assets/images/202506/book/item6.png') },
        { id: 6397, img_url: require('@/assets/images/202506/book/item7.png') },
        { id: 6032, img_url: require('@/assets/images/202506/book/item8.png') },
        { id: 7093, img_url: require('@/assets/images/202506/book/item9.png') },
        { id: 10181, img_url: require('@/assets/images/202506/book/item10.png') },
        { id: 9669, img_url: require('@/assets/images/202506/book/item11.png') },
        { id: 6243, img_url: require('@/assets/images/202506/book/item12.png') }
      ],
      bookData2: [
        { id: 10708, img_url: require('@/assets/images/202506/book2/item1.png') },
        { id: 10528, img_url: require('@/assets/images/202506/book2/item2.png') },
        { id: 9601, img_url: require('@/assets/images/202506/book2/item3.png') },
        { id: 7582, img_url: require('@/assets/images/202506/book2/item4.png') },
        { id: 9440, img_url: require('@/assets/images/202506/book2/item5.png') },
        { id: 7287, img_url: require('@/assets/images/202506/book2/item6.png') },
        { id: 7231, img_url: require('@/assets/images/202506/book2/item7.png') },
        { id: 10694, img_url: require('@/assets/images/202506/book2/item8.png') },
        { id: 8465, img_url: require('@/assets/images/202506/book2/item9.png') },
        { id: 7219, img_url: require('@/assets/images/202506/book2/item10.png') },
        { id: 10775, img_url: require('@/assets/images/202506/book2/item11.png') },
        { id: 10586, img_url: require('@/assets/images/202506/book2/item12.png') },
        { id: 10685, img_url: require('@/assets/images/202506/book2/item13.png') },
        { id: 10550, img_url: require('@/assets/images/202506/book2/item14.png') },
        { id: 10340, img_url: require('@/assets/images/202506/book2/item15.png') },
        { id: 9317, img_url: require('@/assets/images/202506/book2/item16.png') },
        { id: 8926, img_url: require('@/assets/images/202506/book2/item17.png') },
        { id: 10274, img_url: require('@/assets/images/202506/book2/item18.png') },
        { id: 10235, img_url: require('@/assets/images/202506/book2/item19.png') },
        { id: 6572, img_url: require('@/assets/images/202506/book2/item20.png') }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
  #June2025 {
    background: rgb(141, 210, 227);
  }
</style>
